const APP_CONFIG = {
  FRONTEND_VERSION: 47,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
